<template>
  <div class="sales-layout">
    <aside class="sales-sidebar">
      <div class="sales-sidebar-title">
        <span>{{ salesTitle }}</span>
      </div>
      <nav class="sales-menu">
        <button
          v-for="(item, index) in menuList"
          v-if="item.hidden !== true"
          :key="index"
          type="button"
          class="sales-menu-item"
          :class="{ active: toca === item.path }"
          @click="copu(item, index)"
        >
          <i :class="['sales-menu-icon', menuIcon(item)]"></i>
          <span>{{ sxtitle(item) }}</span>
        </button>
      </nav>
    </aside>

    <section class="sales-content">
      <Retailer v-if="toca=='Retailer'" />
      <FlowingWater v-if="toca=='FlowingWater'" />
      <PublishDocuments v-if="toca=='PublishDocuments'" />
      <PublishPublic v-if="toca=='PublishPublic'" />
      <Accessories v-if="toca=='Accessories'" />
      <Carprice v-if="toca=='Carprice'" />
      <Tailordera v-if="toca=='Tailordera'" />
      <DeliveryNote v-if="toca=='DeliveryNote'" />
      <ordera v-if="toca=='ordera'" />
      <Inventorya v-if="toca=='Inventorya'" />
      <ClaimOrder v-if="toca=='ClaimOrder'" />
      <Compensation v-if="toca=='Compensation'" />
      <Invoice v-if="toca=='Invoice'" />
      <cost v-if="toca=='cost'" />
    </section>
  </div>
</template>

<script>

import Retailer from '../Sales/Retailer'//零售商
import FlowingWater from '../account/FlowingWater'//账户
import PublishDocuments from '../document/updata'//发布文档
import PublishPublic from '../publicnotice/updata'//发布公告
import Accessories from '../Sales/Accessories'//配件管理
import Carprice from '../Sales/Carprice'//销售车型
import Tailordera from '../Sales/updonta'//销售尾单
import DeliveryNote from '../sale/fhd'//发货单
import ordera from '../order/indexa'//销售订单
import Inventorya from '../vehicle/Inventorya' //零售商库存
import ClaimOrder from '../sale/ordera' //soupei
import Compensation from '../sale/pfqd' //赔付清单
import Invoice from '../Invoice/index' //发票
import cost from '../fy/index' //费用模板
export default {
  components: {
    Retailer,
    FlowingWater,
    PublishDocuments,
    PublishPublic,
    Accessories,
    Carprice,
    Tailordera,
    DeliveryNote,
    ordera,
    Inventorya,
    ClaimOrder,
    Compensation,
    Invoice,
    cost

  },
  data () {
    return {
      lange:false,
      menuList: [],
      toca:0,
      inle:'zh',
      salesTitle:'销售管理'
    }
  },
  created () {
    let aa = sessionStorage.getItem('i18n')
  
   this.inle=aa
    
    
    if (aa == 'zh') {
      this.lange = false
      this.$i18n.locale = 'zh'
    } else if (aa == 'en'){
      this.lange = true
      this.$i18n.locale = 'en'
    } else {
      this.lange = true
      this.$i18n.locale = 'de'
    }
      let accc =sessionStorage.getItem('xqxq')?sessionStorage.getItem('xqxq'):'0'
      let accd =sessionStorage.getItem('spxq')?sessionStorage.getItem('spxq'):'0'


    let nume = JSON.parse(sessionStorage.getItem('menu'))
    nume.forEach(e=>{
      if(e.path=='/Sales'){
         this.menuList=e.children
         this.salesTitle=this.sxtitle(e)
         if(accc=='1'){
         this.toca='ordera'
         console.log(123,this.toca);
        sessionStorage.removeItem('xqxq')
         }else{
          if(accd=='1'){
         this.toca='ClaimOrder'
         console.log(123,this.toca);
        sessionStorage.removeItem('spxq')
         }else{
          this.toca=e.children[0].path
         }
           
         }
        
      }
    })
 

    
   
  },

  computed: {
  },


  methods: {
    menuIcon(item) {
      const iconMap = {
        Retailer: 'el-icon-office-building',
        FlowingWater: 'el-icon-user',
        PublishDocuments: 'el-icon-document-add',
        PublishPublic: 'el-icon-bell',
        Accessories: 'el-icon-s-grid',
        Carprice: 'el-icon-price-tag',
        Tailordera: 'el-icon-s-order',
        DeliveryNote: 'el-icon-truck',
        ordera: 'el-icon-document',
        Inventorya: 'el-icon-box',
        ClaimOrder: 'el-icon-tickets',
        Compensation: 'el-icon-wallet',
        Invoice: 'el-icon-document-checked',
        cost: 'el-icon-set-up'
      }
      return iconMap[item.path] || 'el-icon-menu'
    },
    copu(e,i){
      this.toca=e.path
    },
         sxtitle(e){
      let a =''
      if(this.inle=='zh'){
        a=e.meta.title
      }
    if(this.inle=='en'){
      if(e.meta.titleEn.indexOf(":") !== -1){
        let c =JSON.parse(e.meta.titleEn)
      
        a=c.en
      }else{
        a=e.meta.titleEn
      }
      

      }
      if(this.inle=='de'){
         if(e.meta.titleEn.indexOf(":") !== -1){
             let d =JSON.parse(e.meta.titleEn)
a=d.de
         } else{
        a=e.meta.titleEn
      } 
         
      
      }
      return a

    },
  },
}
</script>

<!-- 防止样式重叠 -->
<style lang="less" scoped>
.sales-layout {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: stretch;
  background-color: #fff;
  overflow: hidden;
}

.sales-sidebar {
  flex: 0 0 196px;
  min-width: 196px;
  padding: 14px 0 24px;
  background: linear-gradient(180deg, #fbfcff 0%, #f8faff 100%);
  border-right: 1px solid #edf0f5;
  overflow-y: auto;
}

.sales-sidebar-title {
  height: 46px;
  padding: 0 22px;
  display: flex;
  align-items: center;
  color: #202735;
  font-size: 15px;
  font-weight: 600;
}

.sales-menu {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.sales-menu-item {
  position: relative;
  width: 100%;
  height: 44px;
  padding: 0 20px 0 24px;
  display: flex;
  align-items: center;
  gap: 13px;
  border: 0;
  background-color: transparent;
  color: #596274;
  font-family: inherit;
  font-size: 13px;
  text-align: left;
  cursor: pointer;
  transition: color .2s ease, background-color .2s ease;
}

.sales-menu-item::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 3px;
  background-color: transparent;
}

.sales-menu-item:hover {
  color: #2878ff;
  background-color: #f1f6ff;
}

.sales-menu-item.active {
  color: #2878ff;
  background: linear-gradient(90deg, #eef5ff 0%, #f4f8ff 100%);
  font-weight: 600;
}

.sales-menu-item.active::before {
  background-color: #2878ff;
}

.sales-menu-icon {
  width: 16px;
  flex: 0 0 16px;
  color: #717b8d;
  font-size: 15px;
  text-align: center;
}

.sales-menu-item:hover .sales-menu-icon,
.sales-menu-item.active .sales-menu-icon {
  color: #2878ff;
}

.sales-content {
  flex: 1;
  min-width: 0;
  height: calc(100vh - 72px);
  max-height: calc(100vh - 72px);
  padding: 24px 0 24px 30px;
  box-sizing: border-box;
  overflow-y: auto;
}

@media (max-width: 1100px) {
  .sales-sidebar {
    flex-basis: 174px;
    min-width: 174px;
  }

  .sales-content {
    padding-left: 20px;
  }
}
</style>
